(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('docs', {
            parent: 'admin',
            url: '/systerm/swagger',
            data: {
                //authorities: ['ROLE_ADMIN', 'ROLE_PARTNER'],
                pageTitle: 'global.menu.admin.apidocs'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/docs/docs.html'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', function ($translate) {
                    return $translate.refresh();
                }]
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'Principal', '$uibModalStack', 'LoginService', 'Kinou',
                function($stateParams, $state, $uibModal, Principal, $uibModalStack, LoginService, Kinou) {
            	var top = $uibModalStack.getTop();
            	if (top) {
            	    $uibModalStack.dismiss(top.key);
            	}
                Principal.identity().then(function(account) {
                	if (account != null) {
                        var gtc_caretree2_api_swagger_fullaccess = false;
                        var isAdmin = false;
                        var isDeveloper = false;
                        Kinou.isLoginRoleHasFunctions({functions: "GTC_CareTree2_API_Swagger_FullAccess"}, function(result){
                        	if (!result.flag) {
                        		$state.go('accessdenied');
                        	} else {
                        		plan($state, $uibModal, account, isAdmin, isDeveloper, gtc_caretree2_api_swagger_fullaccess);
                        	}
                        });
                	} else {
                		LoginService.open();
                	}
                	
                });
            }]
        });
    }

    function plan($state, $uibModal, account, isAdmin, isDeveloper, gtc_caretree2_api_swagger_fullaccess){
        if (account.authorities.indexOf("ROLE_ADMIN") != -1) {
            isAdmin = true;
        }
        if (account.authorities.indexOf("ROLE_DEVELOPER") != -1) {
            isDeveloper = true;
        }
        if (account.functions != null) {
            for (var i in account.functions) {
                if (account.functions[i] == 'GTC_CareTree2_API_Swagger_FullAccess') {
                    gtc_caretree2_api_swagger_fullaccess = true;
                }
            }
        }
        if (!gtc_caretree2_api_swagger_fullaccess && !isAdmin && !isDeveloper) {
            $state.go('home');
            $uibModal.open({
                templateUrl: 'app/home/dialog/license.html',
                controller: 'HomeLicenseController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg'
            }).result.then(function() {
                $state.go('home', null, { reload: true });
            }, function() {
                $state.go('home');
            });
        }
    }
})();
